

/**
 * @file StylingContext.js
 * @description The context for styling information.
 */

import { createContext } from "react";

/**
 * @type {React.Context<StylingContextValue>}
 * @description The context for styling information.
 */
export const StylingContext = createContext();
